import { render, staticRenderFns } from "./switch-component.vue?vue&type=template&id=80cf7682&scoped=true"
import script from "./switch-component.vue?vue&type=script&lang=js"
export * from "./switch-component.vue?vue&type=script&lang=js"
import style0 from "./switch-component.vue?vue&type=style&index=0&id=80cf7682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80cf7682",
  null
  
)

export default component.exports